import ScalarSpreadsheet from 'components/ScalarSpreadsheet';
import { ScalarSpreadsheetConfigDataInterface } from 'models/interfaces/spreadsheet-types/core-types';
import { useWaterfallContext } from 'pages/Waterfall/data/WaterfallContext/WaterfallContext';

const WaterfallTables = ({
  waterfallSheet,
  fundInvestmentsSheets,
  firmTotalSheet,
}: {
  waterfallSheet: ScalarSpreadsheetConfigDataInterface;
  fundInvestmentsSheets: ScalarSpreadsheetConfigDataInterface[];
  firmTotalSheet?: ScalarSpreadsheetConfigDataInterface;
}) => {
  
  const { onChange, format, formatDispatch } = useWaterfallContext();

  return (
    <div id={waterfallSheet.name} className="always-visible waterfall-tables-container">
      <br />
      <div className="inline-tables" style={{ display: 'flex', gap: '32px', alignItems: 'flex-end' }}>
        <div
          style={{
            flex: '1 1 0',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: '32px',
            alignItems: 'flex-end',
          }}>
          <ScalarSpreadsheet
            {...waterfallSheet}
            showToolbar
            format={format}
            formatDispatch={formatDispatch}
            onChange={onChange}
            tableTerms={{ tableSlug: 'waterfall-table' }}
            disableVerticalScroll
            disablePerfectScrollbar
            sheet={waterfallSheet}
          />
          {fundInvestmentsSheets
            .filter(sheet => sheet?.data)
            .map(fundInvestmentSheet => (
              <ScalarSpreadsheet
                // The name always exists and is unique as it includes the fund id
                key={fundInvestmentSheet.name}
                {...fundInvestmentSheet}
                showToolbar
                format={format}
                disableVerticalScroll
                formatDispatch={formatDispatch}
                disablePerfectScrollbar
                id={fundInvestmentSheet.name}
                tableTerms={{ tableSlug: 'waterfall-table' }}
                onChange={onChange}
                data={fundInvestmentSheet?.data ?? []}
                sheet={fundInvestmentSheet}
              />
            ))}
          {firmTotalSheet && (
            <ScalarSpreadsheet
              {...firmTotalSheet}
              showToolbar
              format={format}
              formatDispatch={formatDispatch}
              onChange={onChange}
              tableTerms={{ tableSlug: 'waterfall-table' }}
              disableVerticalScroll
              disablePerfectScrollbar
              sheet={firmTotalSheet}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default WaterfallTables;
